import { render, staticRenderFns } from "./ArticlesOnSales.vue?vue&type=template&id=f76c0c7e&scoped=true"
import script from "./ArticlesOnSales.vue?vue&type=script&lang=js"
export * from "./ArticlesOnSales.vue?vue&type=script&lang=js"
import style0 from "./ArticlesOnSales.vue?vue&type=style&index=0&id=f76c0c7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f76c0c7e",
  null
  
)

export default component.exports